import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-payment-requests-user',
  imports: [RouterModule],
  templateUrl: './payment-requests-user.html',
})
export class PaymentRequestsUser {

}
